export default "__VITE_ASSET__C$N_xPY6__"